import React, { Fragment } from 'react'
import ListingBadge, { BADGE_ORDER_PRIORITY, BADGE_MODE } from './base'
import { isREO, isPrivateSeller } from './utils'

class BrokerCoopAvailableBadge extends ListingBadge {
  static title = 'Broker Co-op'

  static titleIcon = 'handshake-alt'

  static condensedTitle = 'Broker Commission Available' // TODO: see if we can reconcile these two

  static renderPriority = BADGE_ORDER_PRIORITY.SIXTH

  static contentPositive = true

  static summary = 'Available'

  static shouldBeIncluded(listing) {
    // same for all modes
    return (
      listing.listing_configuration?.broker_commission_message && isREO(listing)
    )
  }

  get content() {
    return (
      <>
        {this.props.listing.listing_configuration.broker_commission_message}{' '}
        commission is available.
      </>
    )
  }
}

class BrokerCoopUnavailableBadge extends ListingBadge {
  static title = 'Broker Co-op'

  static titleIcon = 'handshake-alt'

  static textIcon = 'times'

  static renderPriority = BADGE_ORDER_PRIORITY.SIXTH

  static contentPositive = false

  static summary = 'Not Offered'

  static shouldBeIncluded(listing, badgeMode) {
    // only applies to expanded, hide for condensed. Also hidden for private
    // seller — broker co-op is not surfaced on SmartSale PDPs.
    return (
      badgeMode === BADGE_MODE.EXPANDED &&
      !isPrivateSeller(listing) &&
      !BrokerCoopAvailableBadge.shouldBeIncluded(listing)
    )
  }

  get content() {
    return (
      <span>
        No Broker/Agent commission on this property.{' '}
        <a href='/lp/residential-agents' target='_blank'>
          Learn more about Broker Co-op.
        </a>
      </span>
    )
  }
}

export { BrokerCoopAvailableBadge, BrokerCoopUnavailableBadge }
